import InvestorDashboardPage from "./InvestorDashboardPage"

export default InvestorDashboardPage
